import type {
  BlockScopedPostTarget,
  LearnerInfo,
  OptimisticThreadLike,
  PendingPostLike,
  ThreadItem,
  ThreadWithPostTarget,
} from "./types";

export function postTargetFromPendingPost(
  pendingPost: PendingPostLike,
): BlockScopedPostTarget {
  return pendingPost.postType === "classPost"
    ? { classPostUid: pendingPost.postUid }
    : { learningAssignmentClassPostUid: pendingPost.postUid };
}

export function postTargetFromThread(
  thread: ThreadWithPostTarget | null | undefined,
): BlockScopedPostTarget | null {
  if (!thread) {
    return null;
  }
  if (thread.classPost?.uid) {
    return { classPostUid: thread.classPost.uid };
  }
  if (thread.learningAssignmentClassPost?.uid) {
    return {
      learningAssignmentClassPostUid: thread.learningAssignmentClassPost.uid,
    };
  }
  return null;
}

export function postTitleFromThreadOrOptimistic(
  thread: ThreadItem | null | undefined,
  optimisticThread?: OptimisticThreadLike | null,
): string | undefined {
  return (
    thread?.classPost?.title ??
    thread?.learningAssignmentClassPost?.title ??
    optimisticThread?.pendingPost.postTitle
  );
}

export function learnerSenderFromLearner(learner: LearnerInfo) {
  return {
    uid: learner.uid,
    name: learner.name ?? "",
    photo: null,
    isLearner: true,
  };
}
